<template>
  <div class="login-page-container">
    <div class="login-page">
      <el-container>
        <el-header style="text-align: center;">
          <div style="font-size: 2.8em;font-weight: 600;">
            上海市信息安全行业协会
          </div>
        </el-header>
        <el-container style="padding: 60px 10%;background-color: #314cac;">
          <el-aside width="420px" style="display: flex;align-items: center;">
            <el-card class="scaled-card">
              <h1 style="font-size: 40px; margin: 40px 0;">考生登录</h1>
              <el-form @submit.prevent="handleLogin" size="large" class="login-form">
                <el-form-item label="准考证号" label-width="100px">
                  <el-input v-model="username" required>
                    <template #prefix>
                      <el-icon>
                        <UserFilled />
                      </el-icon>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="身份证号" label-width="100px">
                  <el-input type="password" v-model="password" required>
                    <template #prefix>
                      <el-icon>
                        <Lock />
                      </el-icon>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label-width="100px">
                  <el-button type="primary" :loading="isLoggingIn" @click="handleLogin"
                    style="width: 100%; font-size: large;">立即登录</el-button>
                </el-form-item>
              </el-form>
              <img src="/banquansuoshu.png" alt="" class="banquan">
            </el-card>
          </el-aside>
          <el-main>
            <div class="notice">
              <h2 class="title">考试须知</h2>
              <ol class="rules-list">
                <li>考生须同时持有本人准考证和身份证件于开考前10分钟入场，对号入座，入场后将身份证和准考证放在课桌左上角，便于监考人员查对。</li>
                <li>考生参加考试，只能使用必需的书写文具，如钢笔、铅笔、橡皮等物品。禁止携带书籍、笔记资料、电子设备和与考试无关的物品进入考场。</li>
                <li>开考15分钟后，考生不得入场。开考30分钟后，考生才能交卷出场。考生离场后不得再次进场答卷。</li>
                <li>考场内不得私自借用文具，不许自备草稿纸，不得使用手机、携机或手提电脑等通讯工具，违者作违纪处理。</li>
                <li>考生若遇试题字迹不清，可举手询问，但不得要求监考人员对题意做任何解释或提示。</li>
                <li>考生必须严格遵守考场纪律，考试时不得交头接耳、左顾右盼、抄袭他人试卷、做笔记或与他人进行交流，违者作作弊处理，一律取消考试成绩。</li>
                <li>考生离开考场的次序为监考人员指示为准。违反者无效处理。取得考试资格者视作放弃本次考试。</li>
                <li>考生应自觉服从监考人员管理，不得以任何理由妨碍监考人员进行正常工作。监考人员有权对考场内发生的违规事件进行处理。</li>
              </ol>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ElCard, ElForm, ElFormItem, ElInput, ElButton, ElIcon, ElMessage, ElContainer, ElMain, ElAside, ElHeader, ElFooter} from 'element-plus';
import { UserFilled, Lock } from '@element-plus/icons-vue';

export default {
  name: 'ExamineeLogin',
  components: {
    ElCard,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    ElIcon,
    ElMessage,
    UserFilled,
    Lock,
    ElContainer, 
    ElMain, 
    ElAside, 
    ElHeader, 
    ElFooter
  },
  data() {
    return {
      username: '',
      password: '',
      isLoggingIn: false // 添加一个标志位
    };
  },
  methods: {
    async handleLogin() {
      if (this.isLoggingIn) return; // 如果正在登录，则直接返回
      this.isLoggingIn = true; // 设置标志位为 true

      if (this.username && this.password) {
        try {
          // 添加200毫秒时延
          await new Promise(resolve => setTimeout(resolve, 300));
          if (this.username != "SM4TWG57" || this.password != "310106198308300001") {
            ElMessage.error("账号或密码错误");
            return;
          }
          let res = await fetch("fakeApi/loginExaminee.json").then(res => {
            if (!res.ok) {
              throw new Error("请求失败");
            }
            return res.json();
          })
          
          if (res.code !== "0") {
            ElMessage.error(res.msg || '登录过程中发生错误');
            return;
          }
          const data = await res.data;
          const tokenExpiration = new Date().getTime() + 1000 * 60 * 60 * 10;
          console.log(data)
          const userInfo = {
            uid: data.uid,
            name: data.name,
            gender: data.gender,
            seatNumber: data.seatNumber,
            idCard: data.idCard,
            admissionTicketNumber: data.admissionTicketNumber,
            role: "Examinee",
            tokenExpiration,
            token: data.token,
            uname: data.uname
          };
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          ElMessage.success('登录成功');
          this.$router.push('/examinee-home');
          window.location.reload(true);
        } catch (error) {
          console.error('登录过程中发生错误:', error);
          ElMessage.error(error.message || '登录过程中发生错误');
        } finally {
          this.isLoggingIn = false; // 无论成功还是失败，都重置标志位
        }
      } else {
        this.isLoggingIn = false; // 如果用户名或密码为空，也重置标志位
      }
    }
  }
};
</script>

<style scoped>
.login-page-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-page{
  width: 100%;
}

.el-card {
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  min-height: 400px;
}

.notice {
  color: #f5f5f5;
}

.title {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-left: 24px;

}

.rules-list {
  text-align: left;
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 30px;
}

.banquan {
  height: 40px;
  position: absolute;
  bottom: 20px;
  bottom: 20px;
  left: 150px;
}
.scaled-card {
  width: 100%;
}


</style>
